import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import {
  DashboardFilled,
  LayoutFilled,
  SettingFilled,
  SoundFilled,
  InfoCircleFilled,
  MailFilled,
  WechatFilled,
} from '@ant-design/icons';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import toptippers from '../img/toptippers.svg';

const { Sider } = Layout;
const { SubMenu } = Menu;

interface SidebarProps extends RouteComponentProps {
  collapsed: boolean;
  collapsible?: boolean;
  trigger?: null;
}

const Sidebaar: React.FC<SidebarProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sidebarVisible, setSidebarVisible] = useState<boolean>(false);

  const path = props.location.pathname;

  return (
    <>
      <Sider
        className={sidebarVisible ? 'mobileMenus' : ''}
        trigger={null}
        collapsible
        collapsed={props.collapsed}
        width={200}
        collapsedWidth={0}
      >
        <div className="logo">
          <img src={toptippers} alt="toptippers" />
        </div>
        <Menu theme="dark" mode="inline" selectedKeys={[path]}>
          <Menu.Item key="/dashboard" onClick={() => props.history.push('/dashboard')}>
            <DashboardFilled />
            <span>Dashboard</span>
          </Menu.Item>
          <Menu.Item key="/users" onClick={() => props.history.push('/users')}>
            <svg
              width="18"
              height="22"
              className="mr-2"
              viewBox="0 0 19 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7866 6.53312C15.7866 10.0208 12.9902 12.8174 9.49998 12.8174C6.01099 12.8174 3.21338 10.0208 3.21338 6.53312C3.21338 3.0454 6.01099 0.25 9.49998 0.25C12.9902 0.25 15.7866 3.0454 15.7866 6.53312ZM9.5 24C4.34907 24 0 23.1628 0 19.9328C0 16.7016 4.37639 15.894 9.5 15.894C14.6521 15.894 19 16.7312 19 19.9613C19 23.1925 14.6236 24 9.5 24Z"
                fill="white"
              />
            </svg>
            <span>Manage User</span>
          </Menu.Item>
          <Menu.Item key="/messaging" onClick={() => props.history.push('/messaging')}>
            <i className="fa fa-envelope" aria-hidden="true"></i>
            <span>Messaging</span>
          </Menu.Item>

          <SubMenu
            key="/sport"
            title={
              <span>
                <LayoutFilled />
                <span>Master</span>
              </span>
            }
          >
            <Menu.Item key="1" onClick={() => props.history.push('/sport')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Manage Sport
            </Menu.Item>
            <Menu.Item key="2" onClick={() => props.history.push('/team')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Manage Team
            </Menu.Item>
            <Menu.Item key="4" onClick={() => props.history.push('/round')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Manage Round
            </Menu.Item>
            <Menu.Item key="5" onClick={() => props.history.push('/game')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Manage Game
            </Menu.Item>
            <Menu.Item key="6" onClick={() => props.history.push('/competition')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Manage Competition
            </Menu.Item>
          </SubMenu>
          <Menu.Item key="/ladder" onClick={() => props.history.push('/ladder')}>
            <MailFilled />
            <span>Article</span>
          </Menu.Item>
          <Menu.Item key="/banter" onClick={() => props.history.push('/banter')}>
            <WechatFilled />
            <span>Banter</span>
          </Menu.Item>
          <SubMenu
            key="/cms"
            title={
              <span>
                <SettingFilled />
                <span>CMS</span>
              </span>
            }
          >
            <Menu.Item key="2" onClick={() => props.history.push('/questions')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              FAQs
            </Menu.Item>
            <Menu.Item key="3" onClick={() => props.history.push('/content')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Rules
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="/ad"
            title={
              <span>
                <SoundFilled />
                <span>Ad Manage..</span>
              </span>
            }
          >
            <Menu.Item key="1" onClick={() => props.history.push('/ads')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Ads
            </Menu.Item>
            <Menu.Item key="2" onClick={() => props.history.push('/adreport')}>
              <svg
                width="6"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                className="mr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L6.5 6.5L1 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Report
            </Menu.Item>
          </SubMenu>
          <Menu.Item key="/version" onClick={() => props.history.push('/version')}>
            <InfoCircleFilled />
            <span>Manage Version</span>
          </Menu.Item>
          <Menu.Item key="/secretcomp" onClick={() => props.history.push('/secretcomp')}>
            <i className="fa fa-user-secret" aria-hidden="true"></i>
            <span>Secret Comp</span>
          </Menu.Item>
          <Menu.Item key="/settings" onClick={() => props.history.push('/settings')}>
            <i className="fa fa-cog" aria-hidden="true"></i>
            <span>Settings</span>
          </Menu.Item>
        </Menu>
      </Sider>
    </>
  );
};

export default withRouter(Sidebaar);
